import * as types from './mutation-types'

const state = {
  forms:{
    data: [],
    meta: {},
  },
  form: {
    fields: {
      data: [],
    },
    attributes: {
      title: '',
    },
  },
  submissions: {
    data:[],
    meta: [],
  },
  selectedSubmissions: [],
  membershipForms: [],
  exportingSubmissions: false,
}

const mutations = {
  [types.FORM_SET_FORM](state, Form) {
    state.form = Form
    state.selectedSubmissions = []
  },
  [types.FORM_SET_HIDDEN_MEMBERSHIP_FORMS](state, MembershipForms) {
    state.membershipForms = MembershipForms
  },
  [types.FORM_SET_EDITABLE_MEMBERSHIP_FORMS](state, MembershipForms) {
    state.membershipForms = MembershipForms
  },
  [types.FORM_SET_FORMS](state, Forms) {
    state.forms = Forms
  },
  [types.FORM_SET_FORM_SUBMISSIONS](state, Submissions) {
    state.submissions = Submissions
  },
  [types.FORM_ADD_SELECTED_FORM_SUBMISSION](state, Submission) {
    state.selectedSubmissions.push(Submission)
  },
  [types.FORM_REMOVE_SELECTED_FORM_SUBMISSION](state, Submission) {
    let index= state.selectedSubmissions.findIndex(found => found.id === Submission.id)
    if(index >= 0){
      state.selectedSubmissions.splice(index, 1)
    }
  },
  [types.FORM_SELECT_ALL_FORM_SUBMISSIONS](state, Submissions) {
    state.selectedSubmissions = Submissions
  },
  [types.FORM_RESET_SELECTED_FORM_SUBMISSIONS](state) {
    state.selectedSubmissions = []
  },
  [types.FORMS_START_EXPORTING_SUBMISSIONS](state) {
    state.exportingSubmissions = true
  },
  [types.FORMS_STOP_EXPORTING_SUBMISSIONS](state) {
    state.exportingSubmissions = false
  },
}

export default {
  state,
  mutations,
}